@if (isAPIAvailable()) {
  @if (isConnected) {
    @if (isNavBarFullySet && yearsHaveBeenLoaded()) {
      <i-navbar
        [config]="navbarConfig()"
        (disconnect)="this.authService.logout()"
      >
        <router-outlet></router-outlet
      ></i-navbar>
    }
  } @else {
    <im-login></im-login>
  }
} @else {
  <div class="welcome__container">
    <div class="welcome__container__logo">
      <img src="assets/imandat-logo.svg" />
    </div>
    <div class="welcome__container__text">
      <h1 class="welcome__container__text-title">iMandat</h1>
      <p>{{ "LOGIN.UNAVAILABLE" | translate }}</p>
    </div>
  </div>
}

<p-toast position="bottom-right" [key]="'imandat'"></p-toast>
